import { makeActionCreator } from '../../../../../utilities'
import { BodySurveyConstants } from './bodySurvey.constants'

export const setExamValue = makeActionCreator(BodySurveyConstants.SET_EXAM_VALUE, 'examValues')
export const setExamPNNVValue = makeActionCreator(BodySurveyConstants.SET_EXAM_PNNV_VALUE, 'examValuesPNNVs')
export const updateExamValue = makeActionCreator(BodySurveyConstants.UPDATE_EXAM_VALUE, '__examValues')
export const updateExamPNNVValue = makeActionCreator(BodySurveyConstants.UPDATE_EXAM_PNNV_VALUE, '__examValuesPNNVs')
export const setFindingsValue = makeActionCreator(BodySurveyConstants.SET_FINDINGS_VALUE, 'findings')
export const setDateTime = makeActionCreator(BodySurveyConstants.SET_DATE_TIME, 'assessDt')
export const saveBodySurvey = makeActionCreator(BodySurveyConstants.SAVE_BODY_SURVEY_ASSESSMENT)
export const resetBodySurvey = makeActionCreator(BodySurveyConstants.RESET_BODY_SURVEY_STATE)
export const resetBodySurveyValues = makeActionCreator(BodySurveyConstants.RESET_BODY_SURVEY_VALUES)
export const setBodySurvey = makeActionCreator(BodySurveyConstants.SET_BODY_SURVEY, 'bodySurvey')
export const setZoomedBodyPart = makeActionCreator(BodySurveyConstants.SET_ZOOMED_BODY_PART, '__zoomedBodyPart')
export const setSelectedBodyPart = makeActionCreator(BodySurveyConstants.SET_SELECTED_BODY_PART, '__selectedBodyPart')
export const setZoomEnabledBodyParts = makeActionCreator(
  BodySurveyConstants.SET_ZOOMED_ENABLED_BODY_PARTS,
  '__zoomEnabledBodyParts'
)
export const setSelectedBodyPartData = makeActionCreator(
  BodySurveyConstants.SET_SELECTED_BODY_PARTS,
  '__selectedBodyParts'
)
export const deleteBodySurveyExam = makeActionCreator(BodySurveyConstants.DELETE_BODY_SURVEY_EXAM, '__deleteExam')
export const setFindingsComments = makeActionCreator(
  BodySurveyConstants.SET_COMMENTS,
  '__comments',
  '__commentLocation'
)
export const setDocumentFindings = makeActionCreator(BodySurveyConstants.SET_DOCUMENT_FINDING, '__documentFindings')
export const setAssessmentSeq = makeActionCreator(BodySurveyConstants.SET_ASSESSMENT_SEQ, 'seq')
export const deleteBodyLocationFinding = makeActionCreator(
  BodySurveyConstants.DELETE_BODY_LOCATION_FINDING,
  '__deleteBodyLocationFinding'
)
export const setDefaults = makeActionCreator(BodySurveyConstants.SET_DEFAULTS, '__setDefaults')
export const setChestLungMode = makeActionCreator(BodySurveyConstants.SET_CHEST_LUNG_MODE, '__chestLungMode')
export const deleteSummaryData = makeActionCreator(
  BodySurveyConstants.DELETE_SUMMARY_DATA,
  '__deleteSummaryExams',
  '__deleteSummaryFindings'
)
export const setExaminationInProgress = makeActionCreator(
  BodySurveyConstants.SET_EXAMINATION_IN_PROGRESS,
  '__examinationInProgress'
)
export const setZoomVisible = makeActionCreator(BodySurveyConstants.SET_ZOOM_VISIBLE, '__setZoomVisible')
export const setEnabledZoom = makeActionCreator(BodySurveyConstants.SET_ENABLE_ZOOM, '__enabledZoom')
export const setSequence = makeActionCreator(BodySurveyConstants.SET_SEQUENCE, '__sequenceOperationType')
export const setBOD = makeActionCreator(BodySurveyConstants.SET_BOD)
export const setBodValue = makeActionCreator(BodySurveyConstants.SET_BOD_VALUE, '__bod')
